import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { encryptAES, decryptAES } from "./cryptoUtils";
import {getApgJWT} from "./getApgJWT";

const BASE_URL = process.env.REACT_APP_SSO_URL;
const apiClient3 = axios.create({
 baseURL: BASE_URL,
 headers: { 'Content-Type': 'application/json' },
 withCredentials: false,
});
/* -------------------- REQUEST INTERCEPTOR -------------------- */
apiClient3.interceptors.request.use(
  (config) => {
    const apigeeKey = process.env.REACT_APP_JWT_USERNAME;
    const token = localStorage.getItem("session_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  
    // ✅ ADD: Encryption (same as PROD)
    if (config.method === "post" && config.data) {
      console.log("POST BEFORE BODY ENC",config.data);
      const plainString = JSON.stringify(config.data);
      const encryptedPayload = encryptAES(plainString);
      config.data = { encryptedRequest: encryptedPayload };
    }
    return config;
  },
  (error) => Promise.reject(error)
 );
 /* -------------------- RESPONSE INTERCEPTOR -------------------- */
 apiClient3.interceptors.response.use(
  (response) => {
    // ✅ KEEP: Token persistence logic
    const token = response.data?.token;
    if (token) {
      localStorage.setItem("session_token", token);
      if (token.split(".").length === 3) {
        try {
          const decoded = jwtDecode(token);
          if (decoded?.exp) {
            localStorage.setItem("app_jwt_expiry", decoded.exp * 1000);
          }
        } catch {
          /* nop */
        }
      }
    }
    // ✅ ADD: Decryption (same as PROD)
    if (response.data?.encryptedResponse) {
      try {
        const decrypted = decryptAES(response.data.encryptedResponse);
        response.data = JSON.parse(decrypted);
      } catch {
        /* noop */
      }
    }
    return response;
  },
  (error) => {
    // ✅ KEEP: Existing UAT auth failure handling
    if (error?.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
 );
 // --------------------------------------------------
 // SSO APIs
 // --------------------------------------------------
 /**
 * Generate SSO key
 * Backend expects:
 *  - user_id
 *  - source (ipruedge | equote)
 *  - user_type (agent | ntid)
 *
 * Returns:
 *  encUser|encKey|encSource|encUserType
 */
  export const generateKey = async (userId, source, userType) => {
     const res = await apiClient3.post(
       "/biu-nova/nova/generate/key",
       {
         agentId: userId,
         source: source,
         user_type: userType
       }     
     );
     return res.data.key;
    };
    /**
    * Validate SSO key and complete login
    * Backend expects full encrypted key
    */
      export const updateUserIdSSO = async (combinedKey) => {
        console.log("Key recvd",combinedKey);
        const oauthJwt = await getApgJWT();
        const res = await apiClient3.post(
          "/biu-nova/nova/sso-jwt",
          { key: combinedKey },
          {
            headers: {
              Authorization: `Bearer ${oauthJwt}`,
            },
          }
        );
        return res.data; // Apigee session token
       };
    